import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isVendor: false,
  isLolVendor: false,
  isToUseAuthZero: false,
};

export const appSlice = createSlice({
  name: "APP",
  initialState,
  reducers: {
    SET_IS_VENDOR: (state, action) => {
      state.isVendor = action.payload;
    },
    SET_IS_LOL_VENDOR: (state, action) => {
      state.isLolVendor = action.payload;
    },
    SET_IS_TO_USE_AUTH_ZERO: (state, action) => {
      state.isToUseAuthZero = action.payload;
    },
  },
});

export const { SET_IS_VENDOR, SET_IS_LOL_VENDOR, SET_IS_TO_USE_AUTH_ZERO } =
  appSlice.actions;
export default appSlice.reducer;
